module.exports = __webpack_public_path__ + "static/media/coffee-glass-empty.c9f11be3.png";